// frontend/src/lib/intentParser.ts

// A simple NLP parser to extract key information from a user's chart request.

export interface ParsedIntent {
  metrics: string[];
  dimensions: string[];
  dateRange: string | null;
  chartType: 'bar' | 'line' | 'pie' | 'table' | null;
  originalIntent: string;
}

// Keywords to identify different parts of the request
const METRIC_KEYWORDS = ['users', 'sessions', 'page views', 'revenue', 'sales', 'signups', 'clicks', 'conversions'];
const DIMENSION_KEYWORDS = ['country', 'city', 'device', 'browser', 'source', 'medium', 'page', 'product', 'campaign'];
const DATE_RANGE_KEYWORDS = [
  /last (\d+) days/i,
  /last (\d+) weeks/i,
  /last (\d+) months/i,
  /this month/i,
  /this week/i,
  /today/i,
  /yesterday/i,
];
const CHART_TYPE_KEYWORDS = {
  bar: ['bar chart', 'histogram'],
  line: ['line chart', 'trend', 'time series'],
  pie: ['pie chart', 'breakdown', 'distribution'],
  table: ['table', 'grid', 'list'],
};

export function parseIntent(intent: string): ParsedIntent {
  const lowerIntent = intent.toLowerCase();
  
  // 1. Extract Metrics
  const metrics = METRIC_KEYWORDS.filter(keyword => lowerIntent.includes(keyword));
  
  // 2. Extract Dimensions (prefixed with "by")
  const dimensions = DIMENSION_KEYWORDS.filter(keyword => lowerIntent.includes(`by ${keyword}`));
  
  // 3. Extract Date Range
  let dateRange: string | null = null;
  for (const regex of DATE_RANGE_KEYWORDS) {
    const match = lowerIntent.match(regex);
    if (match) {
      dateRange = match[0];
      break;
    }
  }
  
  // 4. Extract Chart Type
  let chartType: ParsedIntent['chartType'] = null;
  for (const [type, keywords] of Object.entries(CHART_TYPE_KEYWORDS)) {
    if (keywords.some(keyword => lowerIntent.includes(keyword))) {
      chartType = type as ParsedIntent['chartType'];
      break;
    }
  }

  return {
    metrics,
    dimensions,
    dateRange,
    chartType,
    originalIntent: intent,
  };
} 